import { VStack } from '@televet/kibble-ui/build/chakra';
import { Spinner } from '@televet/kibble-ui/build/components/Spinner';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';

export function LoadingColumn(): JSX.Element {
  return (
    <VStack
      className="Board__Column--Loading"
      bg="background.alpha"
      borderRadius="xl"
      h="100%"
      minW="372px"
      maxW="372px"
      justify="center"
      align="center"
    >
      <Text size="sm" variant="subtle">
        Loading Columns...
      </Text>
      <Spinner size="md" />
    </VStack>
  );
}
